import { render, staticRenderFns } from "./OrderStatusCell.vue?vue&type=template&id=76afed63"
import script from "./OrderStatusCell.vue?vue&type=script&lang=ts"
export * from "./OrderStatusCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports